<template>
  <router-view />
</template>

<script>
import axios from "./plugin/axios";
import { SWUSER_HOST, OLDBI_HOST } from "./constants/apiHosts";

export default {
  created() {
    let token = localStorage.getItem("token");

    if (token) {
      axios
        .get(`${SWUSER_HOST}/service/userban/getUserBanInfo?token=${token}`)
        .then((res) => {
          if (res.data.code == 0) {
            localStorage.setItem("banData", JSON.stringify(res.data.data));

            if (
              res.data.data.ban_type == 2 &&
              window.location.href.indexOf("#/login") < 0
            ) {
              this.$message({
                message: res.data.data.ban_reason,
                type: "warning",
                duration: 0,
              });

              localStorage.removeItem("token");

              this.$router.push({ path: "/login" });
            }
          } else {
            console.log(res.data.msg);
          }
        });
    }

    axios
      .get(
        `https://bi.topnews.cn/producers/collect/verify?st=${
          localStorage.getItem("h5DeviceId") || ""
        }`
      )
      .then((res) => {
        if (res.data.code == 200) {
          localStorage.setItem("h5DeviceId", res.data.data);
        } else {
          console.log(res.data.msg);
        }
      });
  },
};
</script>

<style scoped>
@import "./styles/base.scss";
</style>
